<script setup lang="ts">
import { CHART_ENGINE } from '@/shared/lib'

import AmChartsPieChart from './AmChartsPieChart.vue'
import ChartJsPieChart from './ChartJsPieChart.vue'
import type { PieChartProps } from './types'

/**
 * A share of a whole, as slices: one `{ name, value }` per slice.
 *
 * For a handful of slices only — a pie of twenty is a colour-matching exercise, and a
 * ranked list or a `ColumnChart` says the same thing better. It draws nothing at all for an
 * empty list, so pair it with `EmptyState`.
 *
 * Drawn by Chart.js or amCharts, whichever `CHART_ENGINE` names; until one of them goes, a
 * change of behaviour is made in both `ChartJsPieChart.vue` and `AmChartsPieChart.vue`.
 */
defineProps<PieChartProps>()

const engine = CHART_ENGINE === 'amcharts' ? AmChartsPieChart : ChartJsPieChart
</script>

<template>
  <component :is="engine" v-bind="$props" />
</template>
